"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerDataListLoader = void 0;
const dataListLoaders_1 = require("./dataListLoaders");
function registerDataListLoader(kind, loader) {
    dataListLoaders_1.dataListLoaders[kind] = loader;
}
exports.registerDataListLoader = registerDataListLoader;
